export const OCC_ENDPOINTS = {
  productSearch: 'products/search',
};
